var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webdatalist" },
    [
      _c(
        "f7-list",
        {
          staticClass: "searchbar-found",
          attrs: { "media-list": "", accordion: "", id: "bank-list" },
        },
        _vm._l(_vm.filteredBankAccounts, function (account) {
          return _c(
            "f7-list-item",
            {
              key: account.id,
              staticClass: "accordion-item-expanded boxRequest",
              attrs: {
                "accordion-item": "",
                "accordion-item-opened": "",
                media: "<i class='icon list-icon icon-credit_card'></i>",
                title: account.name,
                subtitle: _vm.formattedBankData(account.iban, account.zoneCode),
              },
            },
            [
              _c("f7-accordion-content", { staticClass: "greyfont" }, [
                account.balances !== undefined && account.balances.length > 0
                  ? _c(
                      "div",
                      { staticClass: "data-table card statementTable" },
                      [
                        _c("table", { staticClass: "showLargeScreenOnly" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { width: "10%" } }, [
                                _vm._v(_vm._s(_vm.$t("common.oper_date"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "20%" } }, [
                                _vm._v(_vm._s(_vm.$t("common.oper_id"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "20%" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("common.to_label") +
                                      "/" +
                                      _vm.$t("common.from")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "20%" } }, [
                                _vm._v(_vm._s(_vm.$t("common.oper_label"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "15%" } }, [
                                _vm._v(_vm._s(_vm.$t("common.amnt"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "10%" } }, [
                                _vm._v(_vm._s("Lettrage")),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _c("tr", {
                                staticClass: "mainLineStatementTable",
                              }),
                              _vm._l(account.balances, function (balance) {
                                return _c("tr", [
                                  _c("td", [_vm._v(_vm._s(balance.date))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(balance.endToEndId)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(balance.name))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(balance.remittanceInformation)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    balance.indicator === "0"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                      -\n                    "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                      +\n                    "
                                          ),
                                        ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          balance.amount.replace(".", ",")
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.getCurrency(account.zoneCode)
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatLettrage(balance.lettrage)
                                      )
                                    ),
                                  ]),
                                ])
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "table",
                          {
                            staticClass:
                              "showSmallScreenOnly statementSmallScreen",
                          },
                          [
                            _c(
                              "tbody",
                              _vm._l(account.balances, function (balance) {
                                return _c("tr", [
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "smallScreenStatementDescription pull-left",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.oper_date")) +
                                            " : "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pull-right" }, [
                                      _vm._v(_vm._s(balance.date)),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "smallScreenStatementDescription pull-left",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.oper_id")) +
                                            " : "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pull-right" }, [
                                      _vm._v(_vm._s(balance.endToEndId)),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "smallScreenStatementDescription pull-left",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("common.to_label") +
                                              "/" +
                                              _vm.$t("common.from")
                                          ) + " : "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pull-right" }, [
                                      _vm._v(_vm._s(balance.name)),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "smallScreenStatementDescription pull-left",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.oper_label")) +
                                            " : "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pull-right" }, [
                                      _vm._v(
                                        _vm._s(balance.remittanceInformation)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "smallScreenStatementDescription pull-left",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.amnt")) + " : "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mainLineStatementTable pull-right",
                                      },
                                      [
                                        balance.indicator === "0"
                                          ? _c("span", [_vm._v("-")])
                                          : _c("span", [_vm._v("+")]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              balance.amount.replace(".", ",")
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.getCurrency(account.zoneCode)
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "smallScreenStatementDescription pull-left",
                                      },
                                      [_vm._v(_vm._s("Lettrage") + " : ")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pull-right" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatLettrage(balance.lettrage)
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                      ]
                    )
                  : _c("div", { staticClass: "text-center" }, [
                      _c("div", { staticClass: "emptyStatement" }, [
                        _c("i", { staticClass: "margin-icon" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("bank_accounts.no_statement_available")
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }